import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import './Layout.css';

const Layout: React.FC = () => (
  <div className="layout">
    <a className="skip-link" href="#main-content">
      Skip to content
    </a>
    <Header />
    <main className="main" id="main-content" tabIndex={-1}>
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default Layout;
